<script lang="ts">
  import type { ClassValue } from "svelte/elements";

  interface Props {
    size?: number;
    class?: ClassValue;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M8 8a3.5 3.5 0 100-7 3.5 3.5 0 000 7zm-5.683 3.153A2.868 2.868 0 001 13.566C1 14.358 1.642 15 2.434 15h11.132c.792 0 1.434-.642 1.434-1.434 0-.976-.496-1.885-1.317-2.413l-.104-.067a10 10 0 00-10.833-.206c-.078.047-.16.1-.325.206l-.104.067z"
    fill="currentColor"
  />
</svg>
